import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';
import NumberInput from 'common/components/form/inputs/NumberInput';
import AsyncSelector from 'common/components/selectors/AsyncSelector';
import Select from '@/library/components/form/inputs/select';
import { timezones } from '@/common/utils/fixed';
import { formatUtcOffsetHours, getUtcOffsetHoursFromTimezone } from '@/library/utils/dates';

const getTimezoneSelectLabel = timezone => {
  const offset = formatUtcOffsetHours(getUtcOffsetHoursFromTimezone(timezone));

  return offset ? `${timezone} (UTC${offset})` : timezone;
};

const namedTimezones = timezones
  .filter(({ value }) => !value.startsWith('Etc/GMT'))
  .map(({ value }) => ({
    value,
    label: getTimezoneSelectLabel(value)
  }));

const Airport = ({ formState }) => {
  const { fields, changeField, selectField } = useFormState(formState);

  return (
    <div className="edit-airport">
      <Row className="g-0">
        <Col xs={12}>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>

      <Row className="g-2">
        <Col>
          <Input label="Iata Code" onChange={changeField('iata_code')} {...fields.iata_code} />
        </Col>

        <Col>
          <NumberInput
            label="Latitude"
            decimalScale={15}
            maxLength={15}
            onChange={changeField('lat')}
            {...fields.lat}
          />
        </Col>

        <Col>
          <NumberInput
            label="Longtitude"
            decimalScale={15}
            maxLength={15}
            onChange={changeField('lon')}
            {...fields.lon}
          />
        </Col>
      </Row>

      <Row className="g-2">
        <Col>
          <AsyncSelector
            label="Country"
            onChange={e => selectField('country')(e)}
            type="countries"
            placeholder=""
            isClearable
            {...fields.country}
          />
        </Col>

        <Col>
          <AsyncSelector
            label="Type"
            onChange={e => selectField('airport_type')(e)}
            getOptionValue={option => option.label}
            type="airport-types"
            placeholder=""
            isClearable
            {...fields.airport_type}
          />
        </Col>
      </Row>

      <Row className="g-0">
        <Col xs={12}>
          <Select
            label="Timezone"
            options={namedTimezones}
            getOptionValue={option => option.value}
            getOptionLabel={option => option.label}
            placeholder="Select timezone"
            isClearable
            {...fields.timezone}
            onChange={option => selectField('timezone')(option?.value || null)}
          />
        </Col>
      </Row>

      <Row className="g-2">
        <Col>
          <NumberInput
            label="Elevation"
            onChange={changeField('elevation')}
            {...fields.elevation}
          />
        </Col>

        <Col>
          <Input label="Iso Region" onChange={changeField('iso_region')} {...fields.iso_region} />
        </Col>
      </Row>
    </div>
  );
};

export default Airport;
